export { default as VueNonreactive } from 'vue-nonreactive'